<app-video-analysis (changedEvent)="changed($event)"
                    *ngIf="!existingFormValue?.value"
                    [categoriesData]="categoriesData"
                    [downloadedVideoPrefix]="partnerSummary?.name"
></app-video-analysis>
<app-form-value-summary-field *ngIf="existingFormValue?.value" [value]="existingFormValue"></app-form-value-summary-field>